import React, { useContext, useEffect, useState } from "react";
import AppContext from "../../../container/context";
import ijws from "../../../services/ijws";
import ActionTable from "../../../components/table/ActionTable";
import Form from "../../../components/form";
import { CircularProgress } from "@mui/material";

export default function Aulas({ unidadeId, history }) {
  const { notification, confirm } = useContext(AppContext);
  const [carregando, setCarregando] = useState(false);
  const [aulas, setAulas] = useState([]);
  const [aulaSelecionada, setAulaSelecionada] = useState({});
  const [novaAula, setNovaAula] = useState(false);

  useEffect(() => {
    listarAulas();
  }, []);

  const listarAulas = () => {
    setCarregando(true);
    ijws
      .get("admin/aulas/listar", { unidadeId })
      .then((aulas) => {
        setAulas(aulas);
        setCarregando(false);
        setAulaSelecionada({});
        setNovaAula(false);
      })
      .catch((e) => notification("error", "Erro"));
  };

  const formulario = (aula) => ({
    numero: {
      label: "Número",
      type: "number",
      value: aula.numero,
      space: 3,
      required: true,
    },
    titulo: {
      label: "Título",
      type: "text",
      value: aula.titulo,
      space: 9,
    },

    descricao: {
      label: "Descricao",
      type: "textarea",
      value: aula.descricao,
      space: 12,
    },
  });

  const salvar = (formulario) => {
    const dadosEnviar = formulario;
    dadosEnviar.unidadeId = unidadeId;

    if (aulaSelecionada.id > 0) {
      dadosEnviar.id = aulaSelecionada.id;
      ijws
        .post("admin/aulas/editar", dadosEnviar)
        .then((res) => {
          notification("success", "Dados salvos!");
          return listarAulas();
        })
        .catch((err) => {
          console.log("err", err);
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Número inválido");
            case 2:
              return notification("error", "Unidade inválida");
            default:
              return notification("error", "Erro ao editar aula");
          }
        });
    } else {
      ijws
        .post("admin/aulas/inserir", dadosEnviar)
        .then((res) => {
          notification("success", "Dados salvos!");
          return listarAulas();
        })
        .catch((err) => {
          console.log("err", err);
          const { data } = err;
          switch (data[0]) {
            case 1:
              return notification("error", "Número inválido");
            case 2:
              return notification("error", "Unidade inválida");
            default:
              return notification("error", "Erro ao editar aula");
          }
        });
    }
  };

  const excluir = (aula) => {
    confirm({
      title: "Deseja realmente desativar a aula?",
      label: "Esta ação não poderá ser desfeita.",
      onConfirm: () => {
        ijws
          .post("admin/aulas/inativar", { id: aula.id })
          .then((res) => {
            notification("warning", "Aula desativada.");
            return listarAulas();
          })
          .catch((err) => {
            notification("error", "Erro ao desativar a aula");
          });
      },
    });
  };

  const form = {
    title: aulaSelecionada.id > 0 ? "Editar aula" : "Cadastrar aula",
    form: formulario(aulaSelecionada),
    history,
    close: {
      label: "voltar",
      action: () => {
        setAulaSelecionada({});
        setNovaAula(false);
      },
    },
    submit: {
      action: salvar,
      label: "Salvar",
    },
    customActions:
      aulaSelecionada.id > 0
        ? [
            {
              warning: true,
              label: "remover",
              action: () => excluir(aulaSelecionada),
            },
          ]
        : undefined,
  };

  const tRegistros = {
    title: "Aulas",
    newItemAction: () => {
      setAulaSelecionada({});
      setNovaAula(true);
    },
    onLineClick: (aula) => {
      setNovaAula(false);
      setAulaSelecionada(aula);
    },

    columns: [
      {
        label: "Número",
        name: "numero",
        sortable: true,
      },
      {
        label: "Título",
        name: "titulo",
        sortable: true,
      },
    ],
    array: aulas,
  };

  return (
    <>
      {carregando ? (
        <CircularProgress />
      ) : (
        <>
          {novaAula || aulaSelecionada.id ? (
            <Form formData={form} />
          ) : (
            <ActionTable structure={tRegistros} />
          )}
        </>
      )}
    </>
  );
}
